import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['uploader', 'submitButton']

  connect(){
    const self = this;
    console.log("connecting to form controller")
    if (this.hasUploaderTarget) {
      console.log("have uploader target")
      window.addEventListener("audioRecorder::recordingStarted", function() {
        console.log("triggered form recording started event listener")
        self.submitButtonTarget.classList.add('state--disabled', 'invisible')
      })

      window.addEventListener("audioRecorder::audioRemoved", function() {
        self.submitButtonTarget.classList.remove('invisible')
      })

      window.addEventListener("uploader::uploadStarted", function() {
        console.log("triggered uploader::uploadStarted event listener")
        self.submitButtonTarget.classList.add('state--disabled')
        self.submitButtonTarget.classList.remove('invisible')
        let inProgressUploads = self.element.dataset.inProgressUploads
        inProgressUploads = (typeof inProgressUploads === 'undefined') ? 0 : inProgressUploads;
        self.submitButtonTarget.disabled = true
        self.element.dataset.inProgressUploads = (parseInt(inProgressUploads) + 1)
      })

      window.addEventListener("uploader::uploadEnded", function() {
        const inProgressUploads = self.element.dataset.inProgressUploads
        const recalculatedInProgressUploads = (parseInt(inProgressUploads) - 1)
        self.element.dataset.inProgressUploads = recalculatedInProgressUploads
        if(recalculatedInProgressUploads < 1 || inProgressUploads === undefined){
          self.submitButtonTarget.classList.remove('state--disabled')
          self.submitButtonTarget.disabled = false
        }
      })

    }
  }

}
